@if (!isMobile) {
    <p-overlayPanel #op [dismissable]="true" [appendTo]="'body'" [showCloseIcon]="false" [styleClass]="'p-0'">
        <ng-container *ngTemplateOutlet="guideContent"></ng-container>
    </p-overlayPanel>
} @else {
    <p-sidebar #sidebar [(visible)]="sidebarVisible" [fullScreen]="true" [styleClass]="'mobile-quick-start-sidebar'"
               [showCloseIcon]="false" [appendTo]="'body'">
        <ng-container *ngTemplateOutlet="guideContent"></ng-container>
    </p-sidebar>
}

<ng-template #guideContent>
    <div [ngClass]="isMobile ? 'h-screen flex flex-column' : 'border-round-2xl shadow-6 w-full w-20rem md:w-22rem'">
        <!-- Header -->
        <div class="quick-start-header p-3" [ngClass]="isMobile ? 'flex-shrink-0' : 'text-white border-round-top-2xl'">
            <div class="flex align-items-center justify-content-between gap-2">
                <h3 class="m-0 text-lg font-semibold text-white flex-1 min-w-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ guideTitle }}
                </h3>
                <span class="text-sm font-semibold step-tally">{{ completedSteps }}/{{ maxSteps }}</span>
                <p-button type="button" [text]="true" styleClass="p-1"
                          (click)="hide()" aria-label="Minimize">
                    <i class="pi pi-window-minimize text-white"></i>
                </p-button>
            </div>

            <!-- Progress pills -->
            <div class="flex align-items-center gap-2 mt-3" aria-hidden="true">
                @for (step of displaySteps; track step.key; let i = $index) {
                    <div
                        class="flex-1 border-round step"
                        [class.completed]="i < completedSteps">
                    </div>
                }
            </div>
        </div>

        <!-- Content wrapper -->
        <div [ngClass]="isMobile ? 'flex-1 overflow-auto' : 'quick-start-content-wrapper'">
            <!-- Body -->
            <div class="p-2 surface-card flex flex-column gap-2"
                 [ngClass]="isMobile ? 'h-full' : 'border-round-bottom-2xl'">

                @for (section of displaySections; track section.key) {
                    <div class="quick-start-section border-round-lg"
                         [class.open]="section.isOpen"
                         [class.flat]="!showSectionHeaders">
                        @if (showSectionHeaders) {
                            <button
                                type="button"
                                class="quick-start-section-btn w-full flex align-items-center gap-2 p-3 border-none border-round-lg"
                                (click)="toggleSectionGroup(section.key)"
                                [attr.aria-expanded]="section.isOpen">
                                <span class="flex-1 text-left text-base font-bold">{{ section.title }}</span>
                                <span class="text-sm font-semibold section-tally">
                                    {{ section.completedCount }}/{{ section.steps.length }}
                                </span>
                                <i class="pi expand-icon" [ngClass]="section.isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                            </button>
                        }

                        @if (section.isOpen) {
                            <div class="flex flex-column gap-2"
                                 [ngClass]="showSectionHeaders ? 'px-2 pb-2' : ''">
                                @for (step of section.steps; track step.key) {
                                    <div class="quick-start-step">
                                        <button
                                            type="button"
                                            class="quick-start-header-btn w-full flex align-items-center justify-content-between gap-2 p-2"
                                            [class.active]="step.isOpen"
                                            (click)="toggleStep(step.key)"
                                            [attr.aria-expanded]="step.isOpen">
                                            <div class="flex align-items-center gap-2 min-w-0">
                                                @if (step.notApplicable) {
                                                    <span class="step-waived flex-shrink-0" role="img" aria-label="Not applicable"></span>
                                                } @else if (step.completed) {
                                                    <img
                                                        src="assets/icons/green-check.svg"
                                                        alt="Completed"
                                                        width="16"
                                                        height="16"
                                                        class="flex-shrink-0" />
                                                } @else {
                                                    <span class="border-circle w-1rem h-1rem step-todo flex-shrink-0"></span>
                                                }
                                                <h4 class="m-0 text-sm font-semibold text-left"
                                                    [class.settled]="step.completed">{{ step.title }}</h4>
                                            </div>
                                            <i class="pi expand-icon text-xs" [ngClass]="step.isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                                        </button>

                                        <div class="quick-start-content" [class.open]="step.isOpen"
                                             style="background-color: var(--bg-body)">
                                            <div class="p-3">
                                                <p class="m-0 text-sm">
                                                    {{ step.body }}
                                                </p>
                                                @if (step.notApplicable) {
                                                    <p-button
                                                        severity="secondary"
                                                        type="button"
                                                        styleClass="w-full mt-3"
                                                        (click)="restoreStep(step.key)"
                                                        [label]="restoreLabel">
                                                    </p-button>
                                                } @else {
                                                    <p-button
                                                        severity="secondary"
                                                        type="button"
                                                        styleClass="w-full mt-3"
                                                        (click)="executeStepAction(step.key)"
                                                        [disabled]="!step.enabled"
                                                        [label]="step.cta">
                                                    </p-button>
                                                    @if (step.dismissible && !step.completed) {
                                                        <div class="text-center">
                                                            <p-button
                                                                    [link]="true"
                                                                    [label]="notApplicableLabel"
                                                                    styleClass="w-full mt-2"
                                                                    (click)="markAsNotApplicable(step.key)">
                                                            </p-button>
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }

            </div>
        </div>
    </div>
</ng-template>
